var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isDetailInfo
    ? _c(
        "div",
        { staticClass: "result-list-item active", attrs: { tabindex: "0" } },
        [
          _c("details-view", {
            ref: "detailsView",
            attrs: { activated: _vm.isDetailInfo, "default-entry": this.entry },
            on: { close: _vm.onDetailsClose }
          })
        ],
        1
      )
    : _c(
        "div",
        {
          ref: "resultContainer",
          class: {
            "result-list-item": true,
            "grid-layout": true,
            active: _vm.isActive
          },
          attrs: { tabindex: "0" },
          on: { click: _vm.onDetailsOpen }
        },
        [
          _c("div", { staticClass: "item-name" }, [
            _c("h3", [_vm._v(_vm._s(_vm.entry.address.name))]),
            _vm._v(" "),
            _vm.entry.address.nameAddon2
              ? _c("p", { staticClass: "lead" }, [
                  _vm._v(_vm._s(_vm.entry.address.nameAddon2))
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.distance() > Number.EPSILON
            ? _c("div", { staticClass: "item-distance" }, [
                _c("p", [
                  _vm._v(
                    _vm._s(_vm.$formatNumber(_vm.distance())) +
                      " " +
                      _vm._s(_vm.distanceUnit())
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "item-address" }, [
            _c("address", [
              _c("span", { staticClass: "street-no" }, [
                _vm._v(_vm._s(_vm.entry.address.streetNo))
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "zip" }, [
                _vm._v(_vm._s(_vm.entry.address.zip))
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "city" }, [
                _vm._v(_vm._s(_vm.entry.address.city))
              ])
            ]),
            _vm._v(" "),
            _vm.isNonPublic()
              ? _c("div", { staticClass: "item-info" }, [
                  _c("i", { staticClass: "material-icons" }, [_vm._v("error")]),
                  _vm._v("\n\t\t\tNicht öffentlich zugänglich\n\t\t")
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item-open" }, [
            _vm.entry.businessHours.isOpen
              ? _c("p", [_vm._v("Geöffnet bis " + _vm._s(_vm.openUntil()))])
              : _vm.entry.businessHours.openAt.length
              ? _c("p", [_vm._v("Geschlossen")])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item-divider" })
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }